jQuery(document).ready(function() {
	jQuery('select#work_cat option[value="752"]').attr("selected",true);
});

